export const TestIds = {
  ResponsivePopupContainerBg: 'responsivePopupContainerBg',
} as const;
